module.exports = __webpack_public_path__ + "static/media/thank-you.5414d2ac.svg";